import React from "react";
import "./WesBenefits.css";
const WesBenefits = () => {
  return (
    <div className="wesBenefitsContainer">
      <h2>
        Benefits of <span>WES</span> Verification
      </h2>
      <p>
        People in Bangalore highly value Canada migration. There has been
        significant growth in choosing overseas education and immigration in
        recent years. If you decide to use an immigration consultant for your
        processing, you can choose the best immigration consultancy in
        Karnataka. Goodway Attestation has helped hundreds of people from
        Bangalore reach their dream destination. Our well-trained counselors
        provide relevant and updated information about Canada immigration and
        visa consultation. Canada offers a great opportunity for international
        candidates to migrate, settle, and live in Canada. More than 60 programs
        run in Canada to attract international candidates via the international
        skilled worker category, such as the Express Entry System, Provincial
        Nominee Program (PNP), Atlantic Immigration Pilot Program (AIPP), Rural
        and Northern Immigration Pilot Program (RNIP), etc. Eligibility to apply
        for these programs depends on age, education, work experience, language
        ability, and other factors. These factors are calculated through the
        Comprehensive Ranking System (CRS), a point-based system. Eligible
        candidates can apply for the Express Entry Pool. The Citizenship and
        Immigration Canada (CIC) selects candidates from the Express Entry pool
        based on the highest ranking. Canada immigration agencies can calculate
        your score.
      </p>
      <p>
        The Canada federal government provides Permanent Residency (PR) to
        international skilled workers to attract immigrants and contribute to
        Canada's financial development. Permanent Residency grants non-Canadian
        citizens the right to live and work in Canada without time limits on
        their stay. Benefits of Canadian Permanent Residency include free
        medical coverage, settling with family, work rights for spouses, child
        allowances, old-age pension schemes, pathways to Canadian citizenship,
        free education until high school, unemployment allowances, and more. You
        can learn more about these benefits from Canada PR agencies.
      </p>
      <p>
        Canada has 13 provinces, each with its own Provincial Nominee Program
        (PNP) to improve population and finance. Each province has specific
        eligibility criteria for issuing PR to citizens of other countries, and
        the Federal Government of Canada has the authority to sanction permanent
        residency. PNP provides opportunities for Express Entry ineligible
        candidates and is a fast way of migration with comparatively low
        eligibility requirements. We provide employment recruitment and
        individualized search consulting in Kerala, India.
      </p>
      <p>
        We offer immigration services to skilled professionals, businessmen,
        traders, and family members sponsored by overseas relatives. We provide
        benefits to diploma holders, graduates, postgraduates, traders,
        engineers, teachers, management professionals, doctors, nurses, social
        workers, and allied health professionals. Goodway Attestation's best
        migration service offers a good future, exciting lifestyle, wonderful
        work opportunities, and a great work environment. Our immigration
        services take you through the stage where you happily shake hands with
        our representatives in your new country, and they welcome you with
        congratulations and greetings.
      </p>
      <p>
        Goodway Attestation provides excellent services for acquiring all types
        of visas. Our core values are based on honesty, integrity, and
        competence. We offer practical and effective solutions to our clients at
        very low charges. We have successfully guided thousands of candidates to
        get their respective visas. We can assist you in getting visas to
        Canada. Contact us today to learn more about WES attestation and
        verification services in Bangalore.
      </p>
    </div>
  );
};

export default WesBenefits;
